(() => {
  const selectSize = (button) => {
    const section = button.closest('.cdb-home');
    if (!section) return;

    section.querySelectorAll('[data-cdb-size]').forEach((option) => {
      const selected = option === button;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', String(selected));
    });

    const variantInput = section.querySelector('[data-cdb-variant]');
    const priceOutput = section.querySelector('[data-cdb-current-price]');
    const sizeOutput = section.querySelector('[data-cdb-current-size]');
    const submit = section.querySelector('[data-cdb-add]');
    const label = button.textContent.trim();
    const variantId = button.dataset.variantId;
    const available = button.dataset.available === 'true';
    const specialOrderUrl = button.dataset.specialOrderUrl || '';
    const form = section.querySelector('.cdb-add-form');
    if (form) form.dataset.specialOrderUrl = specialOrderUrl;
    const orderType = section.querySelector('[data-cdb-order-type]');
    if (orderType) orderType.hidden = !specialOrderUrl;

    if (variantInput) variantInput.value = variantId || '';
    if (priceOutput) priceOutput.textContent = button.dataset.price || '';
    if (sizeOutput) sizeOutput.textContent = label;
    if (submit) {
      submit.disabled = !specialOrderUrl && (!variantId || !available);
      const label = submit.querySelector('[data-cdb-add-label]');
      if (label) label.textContent = submit.disabled ? submit.dataset.labelUnavailable : submit.dataset.labelAvailable;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.cdb-add-form') || !form.dataset.specialOrderUrl) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('cdb:enquiry', {
      detail: {kind: 'request', item: 'Polish Oscietra — 1kg', trigger: form.querySelector('[data-cdb-add]')}
    }));
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cdb-size]');
    if (button) selectSize(button);
  });
})();

// Native informational dialogs; checkout remains Shopify's own flow.
document.addEventListener('click', (event) => {
 const trigger = event.target.closest('[data-cdb-dialog]');
 if (!trigger) return;
 const dialog = document.getElementById('cdb-dialog-' + trigger.dataset.cdbDialog);
 if (!dialog) return;
 event.preventDefault();
 dialog.showModal();
 dialog.addEventListener('close', () => trigger.focus(), {once:true});
});

// Drafts remain in memory. Explicit confirmation uses Shopify native contact handling.
(() => {
  const dialog = document.getElementById('cdb-enquiry');
  if (!dialog) return;
  const form = dialog.querySelector('[data-enquiry-form]');
  const preview = dialog.querySelector('[data-enquiry-preview]');
  const fields = Object.fromEntries(['name', 'email', 'type', 'message'].map(name => [name, form.querySelector('[data-field="' + name + '"]')]));
  const send = dialog.querySelector('[data-enquiry-send]');
  const status = dialog.querySelector('[data-enquiry-send-status]');
  let sending = false;
  const resetSending = () => { sending = false; if (send) send.disabled = false; status.textContent = ''; };
  window.addEventListener('pageshow', resetSending);
  const heading = dialog.querySelector('h2');
  const intro = dialog.querySelector('[data-enquiry-intro]');
  const ja = dialog.dataset.language === 'ja';
  const drafts = new Map();
  let key, kind, trigger;
  const titles = {contact:'Contact', professionals:'For Professionals', request:'Request a Product'};
  const descriptions = ja ? {
    contact:'Caviar Dubaiへのお問い合わせ。',
    professionals:'レストラン、ホテル、法人ギフトのお取り扱いについて。',
    request:'気になる産地やサイズ、味わいをお聞かせください。'
  } : {
    contact:'Get in touch with Caviar Dubai.',
    professionals:'For restaurants, hotels and corporate gifting.',
    request:'Tell us about the origins, sizes and flavours you would like to discover.'
  };
  const save = () => {
    if (key) drafts.set(key, Object.fromEntries(Object.entries(fields).map(([name, field]) => [name, field.value])));
  };
  const edit = () => {
    heading.textContent = titles[kind];
    intro.textContent = descriptions[kind];
    form.hidden = false;
    preview.hidden = true;
  };
  const open = (detail) => {
    save();
    kind = titles[detail.kind] ? detail.kind : 'contact';
    key = kind + ':' + (detail.item || '');
    trigger = detail.trigger;
    document.querySelectorAll('dialog[open]').forEach(other => {
      if (other !== dialog) other.close();
    });
    const draft = drafts.get(key);
    form.querySelector('[data-enquiry-fields]').hidden = false;
    form.reset();
    resetSending();
    form.querySelector('[data-enquiry-product]').value = detail.item || '';
    form.querySelectorAll('[data-enquiry-result]').forEach(el => { el.hidden = true; });
    fields.type.value = kind;
    if (detail.item) fields.message.value = ja
      ? '希望商品：' + detail.item + '\nSpecial Orderでの予約を希望します。'
      : 'Requested item: ' + detail.item + '\nPlease advise on a Special Order reservation.';
    if (draft) ['name','email','type','message'].forEach(name => { fields[name].value = draft[name] || ''; });
    const item = dialog.querySelector('[data-enquiry-item]');
    item.hidden = !detail.item;
    item.textContent = detail.item || '';
    edit();
    dialog.showModal();
  };
  document.addEventListener('cdb:enquiry', e => open(e.detail));
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-cdb-enquiry]');
    if (!link) return;
    e.preventDefault();
    open({kind:link.dataset.cdbEnquiry, item:link.dataset.cdbItem, trigger:link});
  });
  const handleSubmit = e => {
    if (e.submitter === send && send && form.dataset.sendEnabled === 'true' && !preview.hidden && !sending) {
      form.hidden = false;
      if (!form.reportValidity()) { e.preventDefault(); edit(); return; }
      sending = true;
      send.disabled = true;
      status.textContent = ja ? '送信しています…' : 'Sending…';
      return; // Preserve Shopify's native POST and spam protection.
    }
    e.preventDefault();
    if (sending) return;
    if (!form.reportValidity()) return;
    save();
    ['name','email','message'].forEach(name => {
      dialog.querySelector('[data-preview-' + name + ']').textContent = fields[name].value;
    });
    dialog.querySelector('[data-preview-product]').textContent = form.querySelector('[data-enquiry-product]').value || (ja ? '指定なし' : 'Not specified');
    dialog.querySelector('[data-preview-type]').textContent = fields.type.selectedOptions[0].textContent;
    heading.textContent = 'Enquiry Preview';
    intro.textContent = ja ? '入力内容をご確認ください。まだ送信されていません。' : 'Please review your enquiry. Nothing has been sent.';
    form.hidden = true;
    preview.hidden = false;
    dialog.querySelector('[data-enquiry-back]').focus();
  };
  form.addEventListener('submit', handleSubmit);
  form.querySelector('[data-enquiry-review]').addEventListener('click', () => handleSubmit({preventDefault() {}, submitter: null}));
  dialog.querySelector('[data-enquiry-back]').addEventListener('click', () => {
    edit();
    fields.name.focus();
  });
  const result = form.querySelector('[data-enquiry-result]');
  if (result) {
    kind = 'contact';
    if (result.dataset.enquiryResult === 'success') form.querySelector('[data-enquiry-fields]').hidden = true;
    dialog.showModal();
  }
  dialog.querySelector('[data-enquiry-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { save(); if (trigger?.isConnected) trigger.focus(); });
})();
